<template>
  <div class="slider">
    <div
      v-swiper:mySwiper="swiperOption"
      class="swiper-container gallery-top gallery1-1"
    >
      <div class="swiper-wrapper">
        <template v-if="detailImages.length">
          <div
            v-for="(image, index) in detailImages"
            :key="index"
            class="swiper-slide"
          >
            <img
              :data-src="getPhotoUrl(image.photo, 720, 540)"
              :alt="getPhotoAlt(image.image_type)"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </template>
        <template v-else>
          <div>
            <img v-lazy="getPhotoUrl('', 720, 540)" :alt="getPhotoAlt(1)" />
          </div>
        </template>
      </div>
    </div>
    <div class="swiper-pagination-thumbs"></div>
    <div v-if="detail.main_photo_info[0]" class="photo-license">
      Photo by <span v-html="detail.main_photo_info[0]" />
    </div>
  </div>
</template>

<script>
import { config } from '@/utils/config'
import { methods } from '@/utils/methods'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    detailImages: {
      type: Array,
      required: true
    }
  },
  computed: {
    swiperOption() {
      return this.createSwiperOption()
    }
  },
  methods: {
    getPhotoUrl(photo, width, height) {
      return methods.getPhotoUrl({ photo, id: this.detail.id, width, height })
    },
    getPhotoAlt(type) {
      return config.imageTypes.find(
        (imageType) => imageType.code === Number(type)
      ).name
    },
    createSwiperOption() {
      return {
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
          loadPrevNext: true
        },
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
          bulletClass: 'swiper-pagination-thumb',
          bulletActiveClass: 'swiper-pagination-thumb-active',
          el: '.swiper-pagination-thumbs',
          clickable: true,
          renderBullet: (index, className) => {
            return (
              '<div class="' +
              className +
              '" style="background-image:url(' +
              this.getPhotoUrl(this.detailImages[index].photo, 160, 120) +
              ');"><span></span></div>'
            )
          }
        }
      }
    }
  }
}
</script>
